import React, { useState } from "react";
import Logo from "../../../assets/img/logo.png";
import { Input } from "@material-ui/core";
import { theme } from "../Login/theme";
import { ThemeProvider } from "@mui/system";
import api from "../../../config/api";
import { SuccessWithButton } from "../../../components/Alert";

function ForgotPassword() {
  const [email, setEmail] = useState({});
  const [message, setMessage] = useState("");

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const res = await api
      .post("/renew-password-desktop", { email })
      .then((res) => {
        if (res.data.success) {
          document.getElementById("btnCallSuccess").click();
        }
      });
    console.log("Res", res);
    res.success ? setMessage("") : setMessage(res.message);
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className="bg-img-login h-100 col-lg-7 d-flex justify-content-start align-items-end ">
            <div className="row m-0">
              <h1 className="title mb-3 text-white fz-34 ff-univanova-300">
                Bem-vindo ao <br />
                <span className="ff-univanova-bold">RESERVEI</span>
              </h1>
              {/* <h2 className="subtitle mb-4 text-white fz-16 ff-univanova-300">
                Lorem ipsum dolor sit amet, consetetur
              </h2> */}
            </div>
          </div>
          <div className="col-lg-5 mt-5 my-lg-auto">
            <form className="px-3 mb-5 mb-lg-0" onSubmit={handleForgotPassword}>
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <div className="mb-4">
                <h2 className="d-flex justify-content-center ff-univanova-600 fz-24 text-cl-cyan">
                  Solicitar troca de senha
                </h2>
              </div>
              <div className="">
                <h2 className="ff-univanova-regular fz-16 text-cl-cyan">
                  Seu e-mail
                </h2>
                <form className="form" noValidate autoComplete="off">
                  <Input
                    onChange={({ target }) => setEmail(target.value)}
                    style={{
                      fontFamily: "Univa Nova",
                      fontSize: "14px",
                      color: "#6D777D",
                      paddingBottom: "0",
                      "::placeholder": {
                        fontFamily: "Univa Nova",
                        fontSize: "14px",
                      },
                      border: "none",
                      ":hover, :focus": { border: "none" },
                    }}
                    className="password input-line form-control ff-univanova-regular fz-14 text-cl-auroMetal px-0 w-90"
                    placeholder="Digite seu e-mail"
                    required
                    name="email"
                    type={"email"}
                    fontFamily="Univa nova"
                  />
                </form>
              </div>
              <div style={{ marginBottom: "24px" }}>
                <button
                  type="submit"
                  className="w-100 btn bg-gradient-cyan-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center ff-univanova-medium"
                >
                  Solicitar troca
                </button>
                <h3 className="mt-2 text-cl-red fz-12 ff-univanova-regular errorMessage">
                  {message}
                </h3>
              </div>
              <div className="d-flex align-items-center justify-content-end check-box">
                <div className="d-flex align-items-center">
                  <span className="text-cl-auroMetal fz-14 ff-univanova">
                    Não tem conta?
                  </span>
                  <div className={`d-flex justify-content-end ms-3`}>
                    <button
                      onClick={() => (document.location.href = "/criar-conta")}
                      className="btn btn-white button-white-primary fz-16 px-4 ff-univanova-medium"
                      type="button"
                    >
                      Criar conta
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <button
        id="btnCallSuccess"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ForgotPassword"
      >
        Chamar modal success
      </button>
      <SuccessWithButton
        id="ForgotPassword"
        title={"Sua solicitação foi realizada com sucesso!"}
        description="verifiquei seu e-mail para realizar a troca de senha"
        buttonOnClick={() => (document.location.href = "/")}
        buttonText="Ok"
      />
    </ThemeProvider>
  );
}

export default ForgotPassword;
